import _extends from "@babel/runtime/helpers/extends";
import React, { useContext } from 'react';
import { useMemoizeFeatureFlags } from '@atlaskit/media-common';
import Loadable from 'react-loadable';
import { CardLoading } from '../..';
const MediaCardContext = /*#__PURE__*/React.createContext({});

const CardLoadingWithContext = () => {
  const props = useContext(MediaCardContext);
  return /*#__PURE__*/React.createElement(CardLoading, props);
};

const MediaCard = Loadable({
  loader: () => import(
  /* webpackChunkName: "@atlaskit-internal_media-card" */
  './index').then(mod => mod.Card),
  loading: () => /*#__PURE__*/React.createElement(CardLoadingWithContext, null)
});
const MediaCardErrorBoundary = Loadable({
  loader: () => import(
  /* webpackChunkName: "@atlaskit-internal_media-card-error-boundary" */
  '../media-card-analytics-error-boundary').then(mod => mod.default),
  loading: () => /*#__PURE__*/React.createElement(CardLoadingWithContext, null)
});
const MediaCardWithMediaClient = Loadable({
  loader: () => import(
  /* webpackChunkName: "@atlaskit-internal_media-client" */
  '@atlaskit/media-client'),
  loading: () => /*#__PURE__*/React.createElement(CardLoadingWithContext, null),
  render: (loaded, props) => /*#__PURE__*/React.createElement(CardWithMediaClient, _extends({}, props, {
    withMediaClient: loaded.withMediaClient
  }))
});

const CardWithMediaClient = props => {
  const {
    withMediaClient,
    featureFlags
  } = props;
  const memoizedFeatureFlags = useMemoizeFeatureFlags(featureFlags);
  const Card = React.useMemo(() => {
    return withMediaClient(MediaCard, memoizedFeatureFlags);
  }, [withMediaClient, memoizedFeatureFlags]);
  return /*#__PURE__*/React.createElement(MediaCardErrorBoundary, null, /*#__PURE__*/React.createElement(Card, props));
};

const CardLoader = props => {
  return /*#__PURE__*/React.createElement(MediaCardContext.Provider, {
    value: props
  }, /*#__PURE__*/React.createElement(MediaCardWithMediaClient, props));
};

export default CardLoader;